

























































































import _ from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('ServiceItem', {
      serviceItems: 'serviceItems',
      serviceItemTotalAvailableQuantity: 'serviceItemTotalAvailableQuantity',
    }),
    ...mapState('ServiceOrder', {
      newBulkServiceOrder: 'newBulkServiceOrder',
    }),
  },
})
export default class ServiceOrderCreateServiceItemsTable extends Vue {
  @Prop({ default: true }) readonly selectedBusiness!: Model;
  newBulkServiceOrder!: ServiceOrderState['newBulkServiceOrder'];
  serviceItems!: Model[];
  serviceItemTotalAvailableQuantity!: [];

  isMounted = false;

  async beforeMount() {
    if (!this.serviceItems.length) {
      await this.$store.dispatch('ServiceItem/fetchList');
    }

    if (!_.isEmpty(this.orderDetails)) {
      this.isMounted = true;
      return;
    }

    this.orderDetails = this.serviceItems.map((serviceItem) => ({
      object_id: serviceItem.object_id,
      quantity: 0,
      required_quantity: 0,
      current_quantity:
        serviceItem.object_id &&
        this.serviceItemTotalAvailableQuantity[serviceItem.object_id]
          ? parseInt(
              this.serviceItemTotalAvailableQuantity[serviceItem.object_id]
            )
          : 0,
      unit_price: this.getUnitPriceByCountry(serviceItem),
    }));

    this.isMounted = true;
  }

  get orderDetails() {
    return this.newBulkServiceOrder.order_details ?? [];
  }
  set orderDetails(v) {
    this.$store.commit('ServiceOrder/SET_NEW_BULK_SERVICE_ORDER', {
      ...this.newBulkServiceOrder,
      order_details: v,
    });
  }

  get total() {
    return _.sumBy(
      this.orderDetails,
      (item) => item.unit_price * item.quantity
    );
  }

  quantityDecrement(i) {
    this.orderDetails[i].quantity--;
  }

  quantityIncrement(i) {
    this.orderDetails[i].quantity++;
  }

  setQuantity(i, value) {
    this.orderDetails[i].quantity = !value || value < 0 ? 0 : value;
  }

  preventNumberSpecialKeys() {
    // ., -, +
    // if ([43, 45, 46].includes(event.keyCode)) {
    //   event.preventDefault()
    // }
  }

  itemAfterTopUp(i) {
    return (
      Number(this.orderDetails[i].current_quantity) +
      Number(this.orderDetails[i].quantity)
    );
  }

  setUnitPrice(value, i) {
    this.orderDetails[i].unit_price = value * 100;
  }

  getUnitPriceByCountry(serviceItem) {
    if (!this.selectedBusiness) {
      return serviceItem.unit_price['AU'];
    }
    return (
      serviceItem.unit_price[this.selectedBusiness.country || 'AU'] ||
      serviceItem.unit_price['AU']
    );
  }
}
